const CLEANUP_KEY = "__mallHeaderHolderSyncCleanup__";
const START_KEY = "__mallHeaderHolderSyncStart__";

function isDefaultTemplatePage() {
  const templateKey = document.body?.dataset?.templateKey
    || document.querySelector(".site-template-root")?.dataset?.templateKey
    || "";

  return templateKey === "default" || document.body?.classList.contains("site-template--default");
}

function createHeaderHolderSync() {
  let resizeObserver = null;
  let mutationObserver = null;
  let syncFrame = null;
  let syncTimers = [];

  function syncHeaderHolderHeight() {
    if (!isDefaultTemplatePage()) {
      return;
    }

    const header = document.getElementById("mall-header-wrap");
    const holder = document.getElementById("mall-header-holder");

    if (!header || !holder) {
      return;
    }

    const headerStyle = window.getComputedStyle(header);
    const isFixedHeader = ["fixed", "sticky"].includes(headerStyle.position);
    const headerHeight = Math.ceil(header.getBoundingClientRect().height);

    if (!isFixedHeader || !headerHeight) {
      return;
    }

    const nextHeight = `${headerHeight}px`;
    if (holder.style.height !== nextHeight) {
      holder.style.height = nextHeight;
    }
    if (holder.style.minHeight !== "0px") {
      holder.style.minHeight = "0";
    }
  }

  function scheduleSync() {
    if (syncFrame) {
      window.cancelAnimationFrame(syncFrame);
    }

    syncFrame = window.requestAnimationFrame(() => {
      syncFrame = null;
      syncHeaderHolderHeight();
    });
  }

  function cleanup() {
    if (syncFrame) {
      window.cancelAnimationFrame(syncFrame);
      syncFrame = null;
    }

    syncTimers.forEach((timer) => window.clearTimeout(timer));
    syncTimers = [];

    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }

    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }

    window.removeEventListener("resize", scheduleSync);
    window.removeEventListener("scroll", scheduleSync);
  }

  function start() {
    cleanup();

    const header = document.getElementById("mall-header-wrap");
    const holder = document.getElementById("mall-header-holder");

    scheduleSync();
    syncTimers = [0, 80, 300, 800, 1600].map((delay) => (
      window.setTimeout(scheduleSync, delay)
    ));

    if (header && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(scheduleSync);
      resizeObserver.observe(header);
    }

    if ((header || holder) && window.MutationObserver) {
      mutationObserver = new MutationObserver(scheduleSync);
      const observerConfig = {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["class", "style"],
      };

      if (header) {
        mutationObserver.observe(header, observerConfig);
      }
      if (holder) {
        mutationObserver.observe(holder, observerConfig);
      }
    }

    window.addEventListener("resize", scheduleSync);
    window.addEventListener("scroll", scheduleSync, { passive: true });
  }

  return { start, cleanup };
}

if (typeof window !== "undefined") {
  window[CLEANUP_KEY]?.();

  const syncController = createHeaderHolderSync();
  window[CLEANUP_KEY] = syncController.cleanup;
  window[START_KEY] = syncController.start;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncController.start, { once: true });
  } else {
    syncController.start();
  }
  window.addEventListener("load", syncController.start, { once: true });
}

export default defineNuxtPlugin((nuxtApp) => {
  if (typeof window === "undefined") {
    return;
  }

  nuxtApp.hook("page:finish", () => {
    window[START_KEY]?.();
  });
});
